import { sectionRenderer } from '@theme/section-renderer';
// pilot-cart-removal-v1
import { CartAddEvent } from '@theme/events';
import { updateCeylonaeCart } from './ceylonae-cart-update.js?v=20261003-1';
let busy=false;
let pending;
document.addEventListener('click',async event=>{
 const button=event.target.closest('[data-mcd-tier],[data-mcd-remove]');if(!button||busy)return;
 const line=button.closest('.mcd-line'),shell=button.closest('.mcd-shell');if(!line||!shell)return;
 busy=true;shell.setAttribute('aria-busy','true');shell.querySelector('.mcd-err').hidden=true;
 const root=window.Shopify?.routes?.root||'/';
 const api=async(path,body)=>{
  const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
  try{const response=await fetch(root+path,{method:body?'POST':'GET',headers:{'Content-Type':'application/json'},body:body?JSON.stringify(body):undefined,signal:controller.signal});const data=await response.json();if(!response.ok)throw Error(path+': '+response.status);return data;}
  finally{clearTimeout(timer);}
 };
 try{
  const action={lineKey:line.dataset.key,targetId:button.dataset.mcdTier||null};
  if(pending&&JSON.stringify(pending.action)!==JSON.stringify(action))throw Error('finish-pending-change');
  if(!pending)pending={action,recovery:{}};
  const cart=await updateCeylonaeCart(api,pending.action,pending.recovery);
  const ids=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(e=>e.dataset.sectionId))].slice(0,5);
  const sections=await api('?sections='+encodeURIComponent(ids.join(',')));
  document.dispatchEvent(new CartAddEvent(cart,'ceylonae-cart',{source:'ceylonae-cart',sections,itemCount:cart.item_count}));
  pending=null;
 }catch(error){
  console.error('Ceylonae cart update:',error.message);
  const ids=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(e=>e.dataset.sectionId))];
  await Promise.allSettled(ids.map(id=>sectionRenderer.renderSection(id,{cache:false})));
  document.querySelectorAll('.mcd-err').forEach(el=>{el.hidden=false;});
 }
 finally{busy=false;shell.removeAttribute('aria-busy');document.querySelectorAll('.mcd-shell').forEach(el=>el.removeAttribute('aria-busy'));}
});
